import { UserUnitSettings, UnitConversions } from '../common/constants'

interface UserUnit {
  unitId: number
  precision: number
}

const DEFAULT_PRECISION = 2

/**
 * Get user unit settings for a category with fallback to base units
 * Used when a user (especially guests) doesn't have unit preferences configured
 */
export function getUserUnitSetting(
  unitCategoryId: number | string,
  userUnitSettings: UserUnitSettings,
  unitConversions: UnitConversions
): UserUnit {
  const categoryId = String(unitCategoryId)

  // Return user's setting if it exists
  if (userUnitSettings[categoryId]) {
    return userUnitSettings[categoryId]
  }

  // Fall back to base unit from unit conversions
  const categoryConversions = unitConversions[unitCategoryId as keyof UnitConversions]
  if (categoryConversions?.metadata?.baseUnitId) {
    return {
      unitId: categoryConversions.metadata.baseUnitId,
      precision: DEFAULT_PRECISION,
    }
  }

  // Last resort fallback
  console.warn(`No unit settings found for category ${unitCategoryId}, using defaults`)
  return {
    unitId: 1,
    precision: DEFAULT_PRECISION,
  }
}
